export const specialsBackground = 'M128.5,250.4L6.6,128.5L128.5,6.6l121.9,121.9L128.5,250.4z'
